import React from "react";
import { useTranslation } from "react-i18next";

import { IPropsFC } from "interfaces/intarfaces";

import { IInputHookOut, InputLabel } from "components/Input";
import Select, { ISelectHook } from "components/Select";
import SearchSelect, { ISearchSelect } from "components/SearchSelect";
import { ContainerPD } from "./styles";

import { getCountries, getPhoneCodes } from "utils/fetchMapInfo";
import { useContextHospi } from "context/ContextHospi";
import { AvatarCroper } from "components/AvatarCroper";

import { TLang } from "assets/data/isoNameLanguage";

export const PersonalDetailsEdit: React.FC<{
    firstName: IInputHookOut;
    lastName: IInputHookOut;
    dateBirth?: IInputHookOut;
    birthCountry?: ISearchSelect;
    phoneCode: ISelectHook;
    phone: IInputHookOut;
    photo?: string | undefined;
    readyPhoto?: (file: File | undefined) => void;
}> = ({
    firstName,
    lastName,
    dateBirth,
    birthCountry,
    phoneCode,
    phone,
    photo,
    readyPhoto,
}) => {
        const { userStatus } = useContextHospi();
        const user = userStatus === "host" ? "host" : "student";
        const { t, i18n } = useTranslation(user);

        const titlePholder = (part: string, variable: string): IPropsFC => {
            return {
                title: t(`${user}Profile.${part}.form.${variable}.title`),
                placeholder: t(`${user}Profile.${part}.form.${variable}.placeholder`),
                w: "initial",
                grow: "1",
            };
        };
        const currLang = i18n.language.toUpperCase() as TLang;

        const yearFirstBiggerThan = dateBirth?.value ? !!(!!(dateBirth!.value as string).match(/^(\d{4})[-./](\d{2})[-./](\d{2})$/)
            && dateBirth!.value)
            && +(dateBirth!.value as string).slice(0, 4) >= 1900
            && +(dateBirth!.value as string).slice(5, 7) <= 12 : false
        const yearLastBiggerThan = dateBirth?.value ? !!(!!(dateBirth!.value as string).match(/^(\d{2})[-./](\d{2})[-./](\d{4})$/)
            && dateBirth!.value)
            && +(dateBirth!.value as string).slice(6) >= 1900
            && +(dateBirth!.value as string).slice(3, 5) <= 12 : false

        return (
            <ContainerPD
                className={`${user}${photo ? " avatar" : ""}`}
            >
                {photo && readyPhoto && (
                    <div id="photo">
                        <AvatarCroper getAvatar={readyPhoto} initial={[photo]} />
                    </div>
                )}
                <InputLabel
                    {...firstName}
                    {...titlePholder("personalDetails", "firstName")}
                    id="firstname"
                    maxLength={60}
                />
                <InputLabel
                    {...lastName}
                    {...titlePholder("personalDetails", "lastName")}
                    id="lastname"
                    maxLength={60}
                />
                {userStatus === "student" && dateBirth && (
                    <InputLabel
                        {...dateBirth}
                        {...titlePholder("personalDetails", "birthDate")}
                        // error={true}
                        error={(dateBirth.value as string).length ? !(yearFirstBiggerThan || yearLastBiggerThan) : false}
                        id="birthdate"
                        type="date"
                        min="1900-01-01"
                        max={new Date().toISOString().split("T")[0]}
                    />
                )}
                {userStatus === "student" && birthCountry && (
                    <SearchSelect
                        {...birthCountry}
                        {...titlePholder("personalDetails", "birthCountry")}
                        items={getCountries(currLang)}
                        id="birthcountry"
                        topValues={["BE", "NL"]}
                    />
                )}
                <SearchSelect
                    {...phoneCode}
                    {...titlePholder("personalDetails", "countryCode")}
                    items={getPhoneCodes()}
                    id="countrycode"
                    topValues={["+31", "+32", "+49"]}
                />
                <InputLabel
                    {...phone}
                    {...titlePholder("personalDetails", "phone")}
                    type="number"
                    id="phone"
                />
            </ContainerPD>
        );
    };
